export const COUNTRY_UZBEKISTAN = '860';
